import { getOr } from 'lodash/fp';
import createReducer from '../../../helpers/createReducer';
import {
  requestOtp,
  verifyOtp,
  forgotPassword
} from '../../sagas/mfa-auth/routines';
import { resetMfaAuth } from '../../actions';

const initialState = {
  requesting: false,
  error: null,
  info: null,
  mfaRequired: false,
  maskedEmail: null
};

const getErrorMessage = error =>
  getOr('Something went wrong. Please try again.', 'message', error);

const requestingHandler = routine => ({
  [routine.TRIGGER]: state => ({
    ...state,
    requesting: true,
    error: null,
    info: null
  }),
  [routine.FAILURE]: (state, { payload }) => ({
    ...state,
    error: getErrorMessage(payload)
  }),
  [routine.FULFILL]: state => ({
    ...state,
    requesting: false
  })
});

export default createReducer(initialState, {
  ...requestingHandler(requestOtp),
  [requestOtp.SUCCESS]: (state, { payload: { response } }) => {
    if (!response.mfaRequired) {
      return state;
    }
    return {
      ...state,
      mfaRequired: true,
      maskedEmail: response.email || state.maskedEmail,
      info: state.mfaRequired
        ? 'A new verification code has been sent to your email address.'
        : 'We sent a verification code to your email address.'
    };
  },
  ...requestingHandler(verifyOtp),
  ...requestingHandler(forgotPassword),
  [forgotPassword.SUCCESS]: (state, { payload: { response } }) => ({
    ...state,
    info:
      getOr(null, 'message', response) ||
      'If the account exists, a password reset link has been sent to the registered email address.'
  }),
  [resetMfaAuth.toString()]: () => ({ ...initialState })
});
